import { render, staticRenderFns } from "./lookUpvote.vue?vue&type=template&id=0b511020&scoped=true&"
import script from "./lookUpvote.vue?vue&type=script&lang=js&"
export * from "./lookUpvote.vue?vue&type=script&lang=js&"
import style0 from "./lookUpvote.vue?vue&type=style&index=0&id=0b511020&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b511020",
  null
  
)

export default component.exports